import SpecializationForm from './specialization-form';

export default SpecializationForm;
